import { paymentState } from "@1-now/booking-core";

/**
 * A pay-later reservation with nothing paid on it yet (1NOW-11198). Its booking page is the Reserved page (what is
 * due, Pay and book) until it is paid: no Edit, Cancel, ID, insurance or other bookings (1NOW-11476).
 *
 * Read from the booking itself, not from the way the renter got to the page (the reservation, Track my booking, a
 * link): a card booking, a paid reservation and a partly paid one are not this, and show as they always have.
 */
export const reservationUnpaid = (booking: any): boolean =>
  booking?.pay_later === true &&
  paymentState(booking).status === "un-paid" &&
  // A later cycle of a long-term stay (main_booking_uuid set) is not the reservation: a renter mid-stay keeps the
  // whole page while the next cycle is unpaid (1NOW-11476).
  !booking?.main_booking_uuid;
